{
  "validation.maxAttachments": "Vain {{max}} liitettä sallitaan.",
  "validation.minAttachments": "vähintään {{min}} liitettä tarvitaan",
  "validation.maxAttachmentSize": "Liitetiedostojen koko ei saa ylittää {{max}} megatavua.",
  "validation.attachmentListItemRequired": "Liitä liite \"{{Category}}",
  "validation.attachmentListItemMaxAttachments": "Vain {{max}} liitettä kategoriaan \"{{category}}\" on sallittu.",
  "validation.attachmentListItemMaxAttachmentSize": "{{category}}-liitteiden koko ei voi ylittää {{max}} megatavua.",
  "attachment.bsoCategory.DiagnosticReport": "Vianmääritysraportti",
  "attachment.bsoCategory.InvoiceDocument": "Lasku",
  "attachment.bsoCategory.ShippingDocument": "Toimitusasiakirja",
  "attachment.bsoCategory.Letter": "Kirje",
  "attachment.bsoCategory.PictureReference": "Kuvaviite",
  "attachment.bsoCategory.BugReport": "Vikailmoitus",
  "attachment.bsoCategory.Other": "Muu",
  "attachment.bsoCategory.Unclassified": "Ei luokiteltu",
  "attachment.bsoCategory.ServiceForms": "Palvelulomake",
  "attachment.bsoCategory.RegistrationDocument": "Rekisteröintiasiakirja",
  "attachment.bsoCategory.ShopInside": "Kuva myymälän sisältä",
  "attachment.bsoCategory.ShopImageMigration": "Kaupan kuvan siirto",
  "attachment.bsoCategory.ShopImage": "Kuva liikkeen julkisivusta",
  "attachment.uploadButton": "Lataa {{category}}",
  "attachment.uploadDropdown": "Lataa tiedosto"
}